const HINTTEXT_TYPE = {
  INFO: 'info',
  ERROR: 'error',
};

export { HINTTEXT_TYPE };
